import { Flex, Text } from "@chakra-ui/react";

export default function AccessDenied({ type = "company" }) {
  const notFound =
    "Usuário não encontrado. Por favor, verifique se está acessando a aplicação correta ou entre em contato com o suporte técnico para assistência adicional.";
  const companyError =
    "Acesso Negado: Seu tipo de usuário (RESPONDENTE) não permite acesso a essa aplicação.";
 
    return (
    <Flex
      bg="white"
      w="100vw"
      h="100vh"
      pos="absolute"
      top="0"
      left="0"
      zIndex={2000}
      align="center"
      justify="center"
    >
      <Text maxW="80%" textAlign="center">
        {type === "company" ? companyError : notFound}
      </Text>
    </Flex>
  );
}
